// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Contact Section */
#contact {
    padding: 100px 0 60px;
    background: linear-gradient(to right, #114040 0%, #144c4c 100%);
    color: #dcca98;
  }
  
  #contact .section-title {
    margin-bottom: 40px;
    color: #dcca98;
  }
  
  #contact .section-title p {
    font-size: 16px;
    color: #dcca98;
  }
  
  #contact h2 {
    color: #dcca98;
    margin-top: 10px;
    margin-bottom: 15px;
    padding-bottom: 15px;
  }
  
  #contact .section-title h2::after {
    position: absolute;
    content: "";
    background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);
    height: 4px;
    width: 60px;
    bottom: 0;
    left: 30px;
  }
  
  #contact h3 {
    color: #dcca98;
    margin-top: 80px;
    margin-bottom: 25px;
    padding-bottom: 20px;
    font-weight: 400;
  }
  
  #contact form {
    padding-top: 20px;
  }
  
  #contact .text-danger {
    color: #cc0033;
    text-align: left;
  }
  
  #contact .btn-custom {
    margin: 30px 0;
    background: transparent;
    border: 2px solid #dcca98;
  }
  
  #contact .btn-custom:hover {
    color: #1f386e;
    background: #dcca98;
  }
  
  label {
    color: #dcca98;
    font-size: 12px;
    font-weight: 400;
    font-family: "Open Sans", sans-serif;
    float: left;
  }
  
  #contact .form-control {
    display: block;
    width: 100%;
    padding: 6px 12px;
    font-size: 16px;
    line-height: 1.42857143;
    color: #444;
    background-color: #dcca98;
    background-image: none;
    border: 1px solid #dcca98;
    border-radius: 0;
    box-shadow: none;
    transition: none;
  }
  
  #contact .form-control:focus {
    border-color: #999;
    outline: 0;
    box-shadow: transparent;
  }
  
  .form-control::-webkit-input-placeholder {
    color: #777;
  }
  
  .form-control:-moz-placeholder {
    color: #777;
  }
  
  .form-control::-moz-placeholder {
    color: #777;
  }
  
  .form-control:-ms-input-placeholder {
    color: #777;
  }
  
  #contact .contact-item{
    margin: 20px 0;
    color: #dcca98;
  }
  
  #contact .contact-item span, p{
    color: #dcca98;
    margin-bottom: 10px;
    display: block;
  }
  
  #contact .contact-item i.fa{
    margin-right: 10px;
    color: #dcca98;
  }
  
  #contact .contact-item p {
    color: #dcca98;
  }
  
  #contact .social {
    border-top: 1px solid rgba(255, 255, 255, 0.15);
    padding-top: 50px;
    margin-top: 50px;
    text-align: center;
  }
  
  #contact .social ul li {
    display: inline-block;
    margin: 0 20px;
  }
  
  #contact .social i.fa {
    font-size: 22px;
    width: 48px;
    height: 48px;
    padding: 12px 0;
    border: 2px solid #dcca98;
    color: #dcca98;
    border-radius: 50%;
    transition: all 0.3s;
  }
  
  #contact .social i.fa:hover {
    color: #608dfd;
    background: #dcca98;
  }
  `, "",{"version":3,"sources":["webpack://./src/home/contact.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,qBAAqB;IACrB,+DAA+D;IAC/D,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,+DAA+D;IAC/D,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,uBAAuB;IACvB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,yBAAyB;IACzB,gBAAgB;IAEhB,gBAAgB;IAGhB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IAEV,uBAAuB;EACzB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,+CAA+C;IAC/C,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB","sourcesContent":["/* Contact Section */\n#contact {\n    padding: 100px 0 60px;\n    background: linear-gradient(to right, #114040 0%, #144c4c 100%);\n    color: #dcca98;\n  }\n  \n  #contact .section-title {\n    margin-bottom: 40px;\n    color: #dcca98;\n  }\n  \n  #contact .section-title p {\n    font-size: 16px;\n    color: #dcca98;\n  }\n  \n  #contact h2 {\n    color: #dcca98;\n    margin-top: 10px;\n    margin-bottom: 15px;\n    padding-bottom: 15px;\n  }\n  \n  #contact .section-title h2::after {\n    position: absolute;\n    content: \"\";\n    background: linear-gradient(to right, #d7c799 0%, #dcca98 100%);\n    height: 4px;\n    width: 60px;\n    bottom: 0;\n    left: 30px;\n  }\n  \n  #contact h3 {\n    color: #dcca98;\n    margin-top: 80px;\n    margin-bottom: 25px;\n    padding-bottom: 20px;\n    font-weight: 400;\n  }\n  \n  #contact form {\n    padding-top: 20px;\n  }\n  \n  #contact .text-danger {\n    color: #cc0033;\n    text-align: left;\n  }\n  \n  #contact .btn-custom {\n    margin: 30px 0;\n    background: transparent;\n    border: 2px solid #dcca98;\n  }\n  \n  #contact .btn-custom:hover {\n    color: #1f386e;\n    background: #dcca98;\n  }\n  \n  label {\n    color: #dcca98;\n    font-size: 12px;\n    font-weight: 400;\n    font-family: \"Open Sans\", sans-serif;\n    float: left;\n  }\n  \n  #contact .form-control {\n    display: block;\n    width: 100%;\n    padding: 6px 12px;\n    font-size: 16px;\n    line-height: 1.42857143;\n    color: #444;\n    background-color: #dcca98;\n    background-image: none;\n    border: 1px solid #dcca98;\n    border-radius: 0;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    -webkit-transition: none;\n    -o-transition: none;\n    transition: none;\n  }\n  \n  #contact .form-control:focus {\n    border-color: #999;\n    outline: 0;\n    -webkit-box-shadow: transparent;\n    box-shadow: transparent;\n  }\n  \n  .form-control::-webkit-input-placeholder {\n    color: #777;\n  }\n  \n  .form-control:-moz-placeholder {\n    color: #777;\n  }\n  \n  .form-control::-moz-placeholder {\n    color: #777;\n  }\n  \n  .form-control:-ms-input-placeholder {\n    color: #777;\n  }\n  \n  #contact .contact-item{\n    margin: 20px 0;\n    color: #dcca98;\n  }\n  \n  #contact .contact-item span, p{\n    color: #dcca98;\n    margin-bottom: 10px;\n    display: block;\n  }\n  \n  #contact .contact-item i.fa{\n    margin-right: 10px;\n    color: #dcca98;\n  }\n  \n  #contact .contact-item p {\n    color: #dcca98;\n  }\n  \n  #contact .social {\n    border-top: 1px solid rgba(255, 255, 255, 0.15);\n    padding-top: 50px;\n    margin-top: 50px;\n    text-align: center;\n  }\n  \n  #contact .social ul li {\n    display: inline-block;\n    margin: 0 20px;\n  }\n  \n  #contact .social i.fa {\n    font-size: 22px;\n    width: 48px;\n    height: 48px;\n    padding: 12px 0;\n    border: 2px solid #dcca98;\n    color: #dcca98;\n    border-radius: 50%;\n    transition: all 0.3s;\n  }\n  \n  #contact .social i.fa:hover {\n    color: #608dfd;\n    background: #dcca98;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
